import { Box, VStack } from '@chakra-ui/react';

import { FilterOption } from '../FilterSelect';

import FilterOptionItem from './FilterOptionItem';

const FilterOptionsList = ({
  options,
  selectedValues,
  onToggle
}: {
  options: FilterOption[];
  selectedValues: FilterOption[];
  onToggle: (value: string) => void;
}) => (
  <Box maxHeight="200px" overflowY="auto">
    <VStack gap={1} alignItems="stretch">
      {options.map((option) => (
        <FilterOptionItem
          key={option.value}
          option={option}
          isSelected={selectedValues.some(v => v.value === option.value)}
          onToggle={onToggle}
        />
      ))}
    </VStack>
  </Box>
);

export default FilterOptionsList;
